"use client"

/**
 * Offline Indicator
 * Shows a banner when the app is offline
 */

import { useNetworkStatus } from "@/hooks/useNetworkStatus"
import { motion, AnimatePresence } from "framer-motion"
import { WifiOff, Wifi } from "lucide-react"

export function OfflineIndicator() {
  const { online } = useNetworkStatus()

  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          exit={{ y: -100 }}
          className="fixed top-0 left-0 right-0 z-50 bg-destructive text-destructive-foreground px-4 py-2 text-center text-sm font-medium"
        >
          <div className="flex items-center justify-center gap-2">
            <WifiOff className="h-4 w-4" />
            You are offline. Some features may not be available.
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export function ConnectionQuality() {
  const { effectiveType, online } = useNetworkStatus()

  if (!online) return null

  const isSlow = effectiveType === "slow-2g" || effectiveType === "2g"

  if (!isSlow) return null

  return (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-40 bg-yellow-500 dark:bg-yellow-600 text-yellow-950 dark:text-yellow-50 px-4 py-2 text-center text-sm font-medium"
    >
      <div className="flex items-center justify-center gap-2">
        <Wifi className="h-4 w-4" />
        Slow connection detected. App may load slower than usual.
      </div>
    </motion.div>
  )
}
